module.exports = __webpack_public_path__ + "img/user_top_bg_item.bec18fd9.png";